import { t } from 'ttag'
import React from 'react'

const EducatorAssociationPanel = ({ codeRequest, onProceed, onCancel }) => {
  if (!codeRequest?.result?.user) {
    return (
      <div className="container">
        <div>
          <h3>{t`Request user not found`}</h3>
        </div>
      </div>
    )
  }

  return (
    <div className="container">
      <div>
        <h3>{t`You are requesting to be managed by:`}</h3>

        <img
          src={codeRequest?.result?.user?.image}
          className="img-circle"
          style={{
            border: '1px solid #ccc',
            backgroundColor: '#eee',
            width: '50px',
            maxHeight: '50px',
            float: 'left'
          }}
        />
        <span
          style={{
            paddingLeft: '10px',
            lineHeight: '50px'
          }}>
          {codeRequest?.result?.user?.name}
        </span>
        <div className="actions text-center" style={{ marginTop: '50px' }}>
          <button className="btn btn-success" onClick={onProceed}>{t`Proceed`}</button>
          &#160;
          <button className="btn btn-danger" onClick={onCancel}>{t`Cancel`}</button>
        </div>
      </div>
    </div>
  )
}

export default EducatorAssociationPanel
